{
  "version": 1,
  "asset_id": "229d53e8-9cfe-4b9e-86a8-5b78402903cb",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/229d53e8-9cfe-4b9e-86a8-5b78402903cb/sleeve-to-bypass-dissection-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/229d53e8-9cfe-4b9e-86a8-5b78402903cb/sleeve-to-bypass-dissection-640.webp",
  "original_filename": "sleeve-to-bypass-dissection-640.webp",
  "size": 29280,
  "content_type": "image/webp",
  "created_at": "2026-10-05T18:59:30Z"
}
